import styled from 'styled-components'

import { color, radius, spacing, typography } from '../../themes'

export const Container = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const Selection = styled.li`
  width: 100%;
  display: flex;
  align-items: center;
  background: ${color('gray.06')};
  border-radius: ${radius('xs')};
`

export const Label = styled.button`
  ${typography('body1')}
  cursor: pointer;
  color: ${color('gray.01')};
  width: 100%;
  display: flex;
  align-items: center;
  padding: ${spacing(2.5, 3)};
  background: none;
`

export const Clear = styled.button`
  cursor: pointer;
  color: ${color('gray.04')};
  padding: ${spacing(0, 2)};
  background: none;
`
